import { defineAsyncComponent } from 'vue';

export default {
	description: 'Группы товаров',
	forms: {
		edit: {
			panel: {
				width: '40%'
			},
			component: defineAsyncComponent(() => import('./forms/Edit.vue'))
		},
		list: {
			component: defineAsyncComponent(() => import('./forms/List.vue'))
		},
		select: {
			panel: {
				width: '50%',
				height: '60%'
			},
			config: {
				fields: {
					number: {
						description: '№'
					},
					name: {
						description: 'Название'
					}
				}
			}
		}
	}
};


